import React from "react";
import { useSelector } from "react-redux";
import {
  getOpcoesMapa,
  getSelecionado,
} from "../../../selectors/mapa.selectors";
import UltimaPosicaoValida from "./UltimaPosicaoValida";
import { getPerfil } from "../../../selectors/usuario.selectors";

const UltimaPosicaoValidaConnected = () => {
  const selecionado = useSelector(getSelecionado);
  const { atual } = useSelector(getOpcoesMapa);
  const perfil = useSelector(getPerfil);

  const points =
    !!atual && !!selecionado
      ? selecionado.posicoes.filter((p) => p.tipo === "P")
      : [];

  points.sort((a, b) => {
    const d1 = new Date(a.horarioPosicao);
    const d2 = new Date(b.horarioPosicao);

    if (d1.getTime() > d2.getTime()) {
      return 1;
    }
    if (d1.getTime() < d2.getTime()) {
      return -1;
    }
    return 0;
  });

  return (
    <UltimaPosicaoValida isEndUser={perfil === "E"} points={points.slice(-1)} />
  );
};

export default UltimaPosicaoValidaConnected;
